module.exports = __webpack_public_path__ + "img/2.68670870.png";